import {noop} from "lodash";
import {
    Add_Map,
    Add_Sub_Customer,
    Attached_Default_Card, Attached_Default_Card_v2, Change_ASN_Submit, Change_ASN_Submit_v2,
    Check_Default_Card_Assignment, Check_Default_Card_Assignment_v2,
    Check_Have_Card, Check_Have_Card_v2,
    Commodity_Delete,
    Commodity_Export,
    Commodity_Info,
    Commodity_List,
    Commodity_Save,
    Commodity_Update,
    Default_Card_Client_Secret, Default_Card_Client_Secret_v2,
    Discount_Management_List,
    Discount_Management_Save,
    Discount_Management_Update,
    Export_Cost_Details,
    Fetch_Card_List, Fetch_Card_List_v2, Generate_Access_Token, Generate_key, Get_Access_Token, Get_Api_Key,
    Map_Info,
    Menu_List_By_Role, Modify_Email_Flag, REGISTER,
    Reset_Password_Sub_Customer,
    Search_Kit,
    Size_Cost_Delete,
    Size_Cost_Export,
    Size_Cost_Info,
    Size_Cost_List,
    Size_Cost_Save,
    Size_Cost_Update,
    Storage_Fee_Authority_Delete,
    Storage_Fee_Authority_Info,
    Storage_Fee_Authority_List,
    Storage_Fee_Authority_Save,
    Storage_Fee_Authority_Update,
    Sub_Role,
    Sub_Roles_Filter,
    Sub_User_Owner_Name, User_Email_Flag_Filter,
    Warehouse_Management_Info,
    Warehouse_Management_List,
    Warehouse_Management_Save,
    Warehouse_Management_Update, Webhook_Add, Webhook_Delete, Webhook_List, Webhook_List_Events, Webhook_Update

} from "../../config";
import api from "../../api/api";
import {ReportsActionType} from "../reports/reportsAction";
import moment from "moment/moment";
import {checkPermission, PERMISSION_DICT} from "../../utils/Users_Roles_Permission";
import {InventoryActionType} from "../inventory/inventoryAction";
import LocalStorage from "../../utils/LocalStorage";
import axios from "axios";


export const SystemActionType = {
    Card_Assignment:"Card_Assignment",
    Set_Card:'Set_Card',
    Check_Card:'Check_Card',
    Commodity_List:'Commodity_List',
    Commodity_Info:'Commodity_Info',
    Commodity_Reset:'Commodity_Reset',
    Size_Cost_List:'Size_Cost_List',
    Size_Cost_Info:'Size_Cost_Info',
    Size_Cost_Reset:'Size_Cost_Reset',
    Sub_Roles_List:'Sub_Roles_List',
    Users_Filter:'Users_Filter',
    Storage_FeeAuthority_List:'Storage_FeeAuthority_List',
    Storage_FeeAuthority_Info:'Storage_FeeAuthority_Info',
    Storage_FeeAuthority_Reset:'Storage_FeeAuthority_Reset',

}

export const check_have_card = (data, onSuccess = noop,onError = noop) => async dispatch => {
    try {
        const ownerId = LocalStorage.getItem("ownerId")
        const url =  ownerId && ownerId.startsWith('NS') ? `${Check_Have_Card_v2}` : `${Check_Have_Card}`
        const response = await api.get(url,
            // {params: {...data}}
        )
        if(response?.status === 200 && response.data.code === 200){
            dispatch({
                type:SystemActionType.Check_Card,
                payload:response?.data?.data
            })
            onSuccess(response.data?.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}


export const sub_user_info = (data,onSuccess = noop,onError = noop) => async dispatch => {

    try {

        if (!checkPermission(PERMISSION_DICT.SystemUserQuery)) return null;
        const url = `${Add_Sub_Customer}/${data?.userId}`
        const response = await api.get(url)
            .then(res=>res)
        if(response?.status === 200 && response.data.code === 200){
            onSuccess(response.data.data)
        } else {
            onError(response.data.msg,response?.data.code)
        }

    } catch (e) {
        onError(e.message)
    }

}


export const sub_user_owner_name = (onSuccess = noop,onError = noop) => async dispatch => {
    try {
        const url = `${Sub_User_Owner_Name}`
        const response = await api.get(url)
        if(response?.status === 200){
            onSuccess(response?.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}




export const check_default_card = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {

        if (!checkPermission(PERMISSION_DICT.AccountCardList)) return null;
        const ownerId = LocalStorage.getItem("ownerId")
        const url =  ownerId && ownerId.startsWith('NS') ? `${Check_Default_Card_Assignment_v2}` : `${Check_Default_Card_Assignment}`
        const response = await api.get(url,
            // {params: {...data}}
        )


        if(response?.status === 200 && response.data.code === 200){
            dispatch({
                type:SystemActionType.Card_Assignment,
                payload:response?.data?.data
            })
            onSuccess(response.data?.data?.paymentMethodList?.length > 0)
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}


export const get_sub_role_list = (onSuccess = noop,onError = noop) => async dispatch => {
    try {
        const url = `${Sub_Role}`
        const response = await api.get(url)

        if(response?.status === 200 && response.data.code === 200){
            onSuccess(response.data.data)
            dispatch({
                type:SystemActionType.Sub_Roles_List,
                payload:response?.data?.data
            })
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}


export const add_sub_customer =  (data,onSuccess = noop, onError = noop)  => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.SystemUserAdd)) return null;
        const url = `${Add_Sub_Customer}`
        const response = await api.post(url,{...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){

            onSuccess("SubCustomerPage.New user created successfully")
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }

}

export const edit_sub_customer =  (data,onSuccess = noop, onError = noop)  => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.SystemUserEdit)) return null;
        const url = `${Add_Sub_Customer}`
        const response = await api.put(url,{...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){

            onSuccess("SubCustomerPage.User edited successfully")
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }

}


export const delete_sub_customer =  (data,onSuccess = noop, onError = noop)  => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.SystemUserRemove)) return null;
        const url = `${Add_Sub_Customer}/${data?.userId}`

        const response = await api.delete(url)
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){

            onSuccess("SubCustomerPage.Delete Sub User successfully")
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }

}

export const change_sub_user_password =  (data,onSuccess = noop, onError = noop)  => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.SystemUserResetPwd)) return null;
        const url = `${Reset_Password_Sub_Customer}`
        const response = await api.put(url,{...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){

            onSuccess("SubCustomerPage.Update Password successfully")
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }

}

export const fetch_role_permission =  (data,onSuccess = noop, onError = noop)  => async dispatch => {
    try {
        const url = `${Menu_List_By_Role}`
        const response = await api.post(url,{...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){

            onSuccess(response?.data?.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }

}


export const fetch_card_list = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {
        const ownerId = LocalStorage.getItem("ownerId")
        const url =  ownerId && ownerId.startsWith('NS') ? `${Fetch_Card_List_v2}` : `${Fetch_Card_List}`
        const response = await api.get(url,
            // {params: {...data}}
        )

        if(response?.status === 200 && response.data.code === 200){
            onSuccess(response.data.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const default_card_client_secret = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {
        if (!checkPermission(PERMISSION_DICT.AccountCustomerInfo)) return null;
        const ownerId = LocalStorage.getItem("ownerId")
        const url =  ownerId && ownerId.startsWith('NS') ? `${Default_Card_Client_Secret_v2}` : `${Default_Card_Client_Secret}`
        const response = await api.post(url,{}
            // data
        )

        if(response?.status === 200 && response.data.code === 200){
            onSuccess(response.data.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const attached_default_card = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {

        if (!checkPermission(PERMISSION_DICT.AccountPaymentId)) return null;
        const ownerId = LocalStorage.getItem("ownerId")
        const url =  ownerId && ownerId.startsWith('NS') ? `${Attached_Default_Card_v2}` : `${Attached_Default_Card}`
        let requestData = {...data}
        delete requestData.userName
        delete requestData.ownerId
        delete requestData.customerId

        const response = await api.post(url,requestData)

        if(response?.status === 200 && response.data.code === 200){
            onSuccess(response.data.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}






export const getCommoditySizeInfo = (data, onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.SystemCommodityInfo)) return null;
        const url = `${Commodity_Info}`
        const response = await api.post(url,data)
        if(response?.status === 200 && response.data.code === 200){
            // dispatch({
            //     type:SystemActionType.Commodity_Info,
            //     payload:response.data
            // })
            onSuccess(response.data)
        } else {
            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const commoditySizeReset = () => async dispatch =>{
    try {
        dispatch({
            type:SystemActionType.Commodity_Reset,
            payload: ""})
    } catch (e) {
        console.log(e.message)
    }
}

export const getCommoditySizeList = (data, onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.SystemCommodityList)) return null;
        const url = `${Commodity_List}`
        const response = await api.post(url,data)
        if(response?.status === 200 && response.data.code === 200){
            // dispatch({
            //     type:SystemActionType.Commodity_List,
            //     payload:response.data
            // })
            onSuccess(response.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const getCommoditySizeSave = (data, onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.SystemCommoditySave)) return null;
        const url = `${Commodity_Save}`
        const response = await api.post(url,data)
        if(response?.status === 200 && response.data.code === 200){
            onSuccess("PriceSettingPage.CommoditySize.Create Commodity Size Successfully")
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const getCommoditySizeUpdate = (data, onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.SystemCommodityUpdate)) return null;
        const url = `${Commodity_Update}`
        const response = await api.post(url,data)
        if(response?.status === 200 && response.data.code === 200){
            onSuccess("PriceSettingPage.CommoditySize.Update Commodity Size Successfully")
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const downloadCommoditySizeList = (data,onSuccess= noop , onError = noop) => async () =>{

    try{
        if (!checkPermission(PERMISSION_DICT.SystemCommodityExport)) return null;
        const xurl = `${Commodity_Export}`
        const response = await api.post(xurl, {...data}, {
            responseType: 'blob' // 设置响应类型为 Blob
        })

        const text = await response.data.text();
        let jsonResponse;
        try {
            jsonResponse = JSON.parse(text);
        } catch (e) {
            // 解析失败，说明响应是一个有效的 Blob 文件
            jsonResponse = null;
        }

        if (response.status === 200 && jsonResponse && jsonResponse.code === 500) {
            // 服务器返回了200但响应体中包含错误码500
            onError(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
            console.error(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
        } else if (response.status === 200) {
            const blob = new Blob([response.data], { type: response.headers['content-type'] }); // 根据响应头中的 content-type 创建 Blob 对象
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            const fileName = `Commodity_Size_List_${moment().format('YYYYMMDD')}.xlsx`
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            // 清理临时 URL 对象
            window.URL.revokeObjectURL(url);
            link.parentNode.removeChild(link);
            onSuccess(fileName)
        } else {
            onError('Failed to download file. Server responded with status:', response.msg)
            console.error('Failed to download file. Server responded with status:', response.status);
        }
    } catch (error) {
        if (error.response) {
            // 请求已发出，服务器响应了状态码范围在 2xx 之外
            console.error('Error response status:', error.response.status);
            console.error('Error response data:', error.response.data);
            onError(`Error occurred while downloading file: Server responded with status ${error.response.status}`);
        } else if (error.request) {
            // 请求已发出但没有收到响应
            console.error('Error request:', error.request);
            onError('Error occurred while downloading file: No response received from server');
        } else {
            // 其他错误
            console.error('Error:', error.message);
            onError(`Error occurred while downloading file: ${error.message}`);
        }
    }

}


export const getCommoditySizeDelete = (data, onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.SystemCommodityDelete)) return null;
        const url = `${Commodity_Delete}`
        const response = await api.post(url,data)
        if(response?.status === 200 && response.data.code === 200){
            onSuccess("PriceSettingPage.CommoditySize.Delete Commodity Size Successfully")
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}


//Size Cost

export const getSizeCostInfo = (data, onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.SystemCostInfo)) return null;
        const url = `${Size_Cost_Info}`
        const response = await api.post(url,data)
        if(response?.status === 200 && response.data.code === 200){
            // dispatch({
            //     type:SystemActionType.Size_Cost_Info,
            //     payload:response.data
            // })
            onSuccess(response.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const sizeCostReset = () => async dispatch =>{
    try {
        dispatch({
            type:SystemActionType.Size_Cost_Reset,
            payload: ""})
    } catch (e) {
        console.log(e.message)
    }
}

export const getSizeCostList = (data, onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.SystemCostList)) return null;
        const url = `${Size_Cost_List}`
        const response = await api.post(url,data)
        if(response?.status === 200 && response.data.code === 200){
            // dispatch({
            //     type:SystemActionType.Size_Cost_List,
            //     payload:response.data
            // })
            onSuccess(response.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const sizeCostSave = (data, onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.SystemCostSave)) return null;
        const url = `${Size_Cost_Save}`
        const response = await api.post(url,data)
        if(response?.status === 200 && response.data.code === 200){
            onSuccess("PriceSettingPage.SizeCost.Create Size Cost Successfully")
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const sizeCostUpdate = (data, onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.SystemCostUpdate)) return null;
        const url = `${Size_Cost_Update}`
        const response = await api.post(url,data)
        if(response?.status === 200 && response.data.code === 200){
            onSuccess("PriceSettingPage.SizeCost.Update Size Cost Successfully")
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}


export const sizeCostDelete = (data, onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.SystemCostDelete)) return null;
        const url = `${Size_Cost_Delete}`
        const response = await api.post(url,data)
        if(response?.status === 200 && response.data.code === 200){
            onSuccess("PriceSettingPage.SizeCost.Delete Size Cost Successfully")
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const downloadSizeCostList = (data,onSuccess= noop , onError = noop) => async () =>{

    try{
        if (!checkPermission(PERMISSION_DICT.SystemCostExport)) return null;
        const xurl = `${Size_Cost_Export}`
        const response = await api.post(xurl, {...data}, {
            responseType: 'blob' // 设置响应类型为 Blob
        })

        const text = await response.data.text();
        let jsonResponse;
        try {
            jsonResponse = JSON.parse(text);
        } catch (e) {
            // 解析失败，说明响应是一个有效的 Blob 文件
            jsonResponse = null;
        }

        if (response.status === 200 && jsonResponse && jsonResponse.code === 500) {
            // 服务器返回了200但响应体中包含错误码500
            onError(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
            console.error(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
        } else if (response.status === 200) {
            const blob = new Blob([response.data], { type: response.headers['content-type'] }); // 根据响应头中的 content-type 创建 Blob 对象
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            const fileName = `Size_Cost_List_${moment().format('YYYYMMDD')}.xlsx`
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            // 清理临时 URL 对象
            window.URL.revokeObjectURL(url);
            link.parentNode.removeChild(link);
            onSuccess(fileName)
        } else {
            onError('Failed to download file. Server responded with status:', response.msg)
            console.error('Failed to download file. Server responded with status:', response.status);
        }
    } catch (error) {
        if (error.response) {
            // 请求已发出，服务器响应了状态码范围在 2xx 之外
            console.error('Error response status:', error.response.status);
            console.error('Error response data:', error.response.data);
            onError(`Error occurred while downloading file: Server responded with status ${error.response.status}`);
        } else if (error.request) {
            // 请求已发出但没有收到响应
            console.error('Error request:', error.request);
            onError('Error occurred while downloading file: No response received from server');
        } else {
            // 其他错误
            console.error('Error:', error.message);
            onError(`Error occurred while downloading file: ${error.message}`);
        }
    }

}


export const subCustomerFilter = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {
        if (!checkPermission(PERMISSION_DICT.SystemUserList)) return null;
        const url = `${Sub_Roles_Filter}`
        const response = await api.get(url,{params: {...data}})
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){

            dispatch({
                type:SystemActionType.Users_Filter,
                payload:response.data
            })
            onSuccess(response.data)
        } else {
            onError(response.data.msg,response?.data.code)
        }
    } catch (e) {
        onError(e.message)
    }

}


export const userEmailFlagFilter = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {
        if (!checkPermission(PERMISSION_DICT.SystemUserEmailFlagList)) return null;
        const url = `${User_Email_Flag_Filter}`
        const response = await api.get(url,{params: {...data}})
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){

            dispatch({
                type:SystemActionType.Users_Filter,
                payload:response.data
            })
            onSuccess(response.data)
        } else {
            onError(response.data.msg,response?.data.code)
        }
    } catch (e) {
        onError(e.message)
    }

}

export const updateNotificationSettings = (data, onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.SystemUserModifyEmailFlag)) return null;
        const url = `${Modify_Email_Flag}`
        const response = await api.post(url,data)
        if(response?.status === 200 && response.data.code === 200){
            onSuccess("Successfully")
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const storageFeeAuthorityFilter = (data, onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.SystemAuthorityList)) return null;
        const url = `${Storage_Fee_Authority_List}`
        const response = await api.post(url,data)
        if(response?.status === 200 && response.data.code === 200){
            dispatch({
                type:SystemActionType.Storage_FeeAuthority_List,
                payload:response.data
            })
            onSuccess(response.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const storageFeeAuthoritySave = (data, onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.SystemAuthoritySave)) return null;
        const url = `${Storage_Fee_Authority_Save}`
        const response = await api.post(url,data)
        if(response?.status === 200 && response.data.code === 200){
            onSuccess("StorageFeeFilterPage.Create Storage Fee Filter Successfully")
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const storageFeeAuthorityUpdate = (data, onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.SystemAuthorityUpdate)) return null;
        const url = `${Storage_Fee_Authority_Update}`
        const response = await api.post(url,data)
        if(response?.status === 200 && response.data.code === 200){
            onSuccess("StorageFeeFilterPage.Update Storage Fee Filter Successfully")
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const storageFeeAuthorityDelete = (data, onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.SystemAuthorityDelete)) return null;
        const url = `${Storage_Fee_Authority_Delete}`
        const response = await api.post(url,data)
        if(response?.status === 200 && response.data.code === 200){
            onSuccess("StorageFeeFilterPage.Delete Storage Fee Filter Successfully")
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const storageFeeAuthorityInfo = (data, onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.SystemAuthorityInfo)) return null;
        const url = `${Storage_Fee_Authority_Info}`
        const response = await api.post(url,data)
        if(response?.status === 200 && response.data.code === 200){
            dispatch({
                type:SystemActionType.Storage_FeeAuthority_Info,
                payload:response.data
            })
            onSuccess(response?.data?.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const storageFeeAuthorityReset = () => async dispatch =>{
    try {
        dispatch({
            type:SystemActionType.Storage_FeeAuthority_Reset,
            payload: ""})
    } catch (e) {
        console.log(e.message)
    }
}


export const discountManagementFilter = (data, onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.CustomerCargoInfo)) return null;
        const url = `${Discount_Management_List}`
        const response = await api.post(url,data)
        if(response?.status === 200 && response.data.code === 200){
            // dispatch({
            //     type:SystemActionType.Storage_FeeAuthority_List,
            //     payload:response.data
            // })
            onSuccess(response.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const discountManagementSave = (data, onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.CustomerCargoDiscountAdd)) return null;
        const url = `${Discount_Management_Save}`
        const response = await api.post(url,data)
        if(response?.status === 200 && response.data.code === 200){
            onSuccess("DiscountManagementPage.Create Discount Info Successfully")
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const discountManagementUpdate = (data, onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.CustomerCargoDiscountModify)) return null;
        const url = `${Discount_Management_Update}`
        const response = await api.post(url,data)
        if(response?.status === 200 && response.data.code === 200){
            onSuccess("DiscountManagementPage.Update Discount Info Successfully")
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}


//warehouse management
export const warehouseManagementFilter = (data, onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.SystemWarehouseList)) return null;
        const url = `${Warehouse_Management_List}`
        const response = await api.post(url,data)
        if(response?.status === 200 && response.data.code === 200){
            onSuccess(response.data)
        } else {
            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const warehouseManagementInfo = (data, onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.SystemWarehouseInfo)) return null;
        const url = `${Warehouse_Management_Info}`
        const response = await api.post(url,data)
        if(response?.status === 200 && response.data.code === 200){
            onSuccess(response?.data?.data)
        } else {
            onError(response?.data?.msg,response?.data?.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const warehouseManagementSave = (data, onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.SystemWarehouseSave)) return null;
        const url = `${Warehouse_Management_Save}`
        const response = await api.post(url,data)
        if(response?.status === 200 && response.data.code === 200){
            onSuccess("WarehousePage.Create Warehouse Info Successfully")
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const warehouseManagementUpdate = (data, onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.SystemWarehouseModify)) return null;
        const url = `${Warehouse_Management_Update}`
        const response = await api.post(url,data)
        if(response?.status === 200 && response.data.code === 200){
            onSuccess("WarehousePage.Update Warehouse Info Successfully")
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const getApiKeys = (onSuccess = noop,onError = noop) => async () => {
    try{
        if (!checkPermission(PERMISSION_DICT.OpenapiGetAppInfo)) return null;
        const url = `${process.env.REACT_APP_OAUTH_BASE_URL}${Get_Api_Key}`

        const lang = LocalStorage.getItem('i18nextLng') === 'zh'?'zh':'en'
        const instance = axios.create({
            baseURL: url,
            timeout: 5000, // 设置超时时间为3秒
            headers:{
                'Authorization': `Bearer ${LocalStorage.getToken()}`,
                'Accept': 'application/json',
                'Language': lang
            }
        });
        const response = await instance.get(url)
            .then(res=>res)

        if (response?.status === 200 && response?.data?.code === 200) {
            onSuccess(response.data.data)
        } else {
            onError(response.data.msg)

        }

    } catch (e) {
        onError(e.message)
    }

}

export const addKeyAndToken = (data,onSuccess = noop,onError = noop) => async () => {
    try{

        if (!checkPermission(PERMISSION_DICT.OpenapiGenerateAppInfo)) return null;
        const url = `${process.env.REACT_APP_OAUTH_BASE_URL}${Generate_key}`

        const lang = LocalStorage.getItem('i18nextLng') === 'zh'?'zh':'en'
        const instance = axios.create({
            baseURL: url,
            timeout: 5000, // 设置超时时间为3秒
            headers:{
                'Authorization': `Bearer ${LocalStorage.getToken()}`,
                'Accept': 'application/json',
                'Language': lang
            }
        });
        const response = await instance.post(url,{...data})
            .then(res=>res)


        if (response?.status === 200 && response?.data?.code === 200) {
            onSuccess(response.data.data)
        } else {
            onError(response.data.msg)

        }

    } catch (e) {
        onError(e.message)
    }

}

export const addToken = (data,onSuccess = noop,onError = noop) => async () => {
    try{

        if (!checkPermission(PERMISSION_DICT.OpenapiGenerateAppToken)) return null;
        const url = `${process.env.REACT_APP_OAUTH_BASE_URL}${Generate_Access_Token}`
        const lang = LocalStorage.getItem('i18nextLng') === 'zh'?'zh':'en'
        const instance = axios.create({
            baseURL: url,
            timeout: 5000, // 设置超时时间为3秒
            headers:{
                'Authorization': `Bearer ${LocalStorage.getToken()}`,
                'Accept': 'application/json',
                'Language': lang
            }
        });
        const response = await instance.post(url,{...data})
            .then(res=>res)

        if (response?.status === 200 && response?.data?.code === 200) {
            onSuccess(response.data.msg)
        } else {
            onError(response.data.msg)

        }

    } catch (e) {
        onError(e.message)
    }

}


export const getAccessToken = (data,onSuccess = noop,onError = noop) => async () => {
    try{

        if (!checkPermission(PERMISSION_DICT.OpenapiGetAppToken)) return null;
        const url = `${process.env.REACT_APP_OAUTH_BASE_URL}${Get_Access_Token}`
        const lang = LocalStorage.getItem('i18nextLng') === 'zh'?'zh':'en'
        const instance = axios.create({
            baseURL: url,
            timeout: 5000, // 设置超时时间为3秒
            headers:{
                'Authorization': `Bearer ${LocalStorage.getToken()}`,
                'Accept': 'application/json',
                'Language': lang
            }
        });
        const response = await instance.post(url,{...data})
            .then(res=>res)


        if (response?.status === 200 && response?.data?.code === 200) {
            onSuccess(response.data.msg)
        } else {
            onError(response.data.msg)

        }

    } catch (e) {
        onError(e.message)
    }

}



export const getWebhookEventsList = (onSuccess = noop,onError = noop) => async () => {
    try {
        const url = `${Webhook_List_Events}`
        const response = await api.get(url)
        if(response?.status === 200 && response.data.code === 200){
            onSuccess(response.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }
    }
    catch (e) {
        onError(e.message)
    }
}


export const getWebhookList = (onSuccess = noop,onError = noop) => async () => {
    try {
        const url = `${Webhook_List}`
        const response = await api.get(url)
        if(response?.status === 200 && response.data.code === 200){
            onSuccess(response.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }
    }
    catch (e) {
        onError(e.message)
    }
}


export const addWebhook = (data,onSuccess = noop,onError = noop) => async () => {
    try {
        const url = `${Webhook_Add}`
        const response = await api.post(url,data)
        if(response?.status === 200 && response.data.code === 200){
            onSuccess("WebhookPage.Create Webhook Successfully")
        } else {

            onError(response.data.msg,response?.data.code)
        }
    }
    catch (e) {
        onError(e.message)
    }

}


export const updateWebhook = (data,onSuccess = noop,onError = noop) => async () => {
    try {
        const url = `${Webhook_Update}`
        const response = await api.post(url,data)
        if(response?.status === 200 && response.data.code === 200){
            onSuccess("WebhookPage.Update Webhook Successfully")
        } else {
            onError(response.data.msg,response?.data.code)
        }
    }
    catch (e) {
        onError(e.message)
    }

}

export const deleteWebhook = (data,onSuccess = noop,onError = noop) => async () => {
    try {
        const url = `${Webhook_Delete}`
        const response = await api.post(url,data)
        if(response?.status === 200 && response.data.code === 200){
            onSuccess("WebhookPage.Delete Webhook Successfully")
        } else {
            onError(response.data.msg,response?.data.code)
        }
    }
    catch (e) {
        onError(e.message)
    }

}





